import { Button, Menu, Box } from "@mui/material";
import { GridCsvExportMenuItem } from "@mui/x-data-grid";
import PropTypes from "prop-types";
import React, { useState } from "react";

const getFileName = (fileName) =>
  typeof fileName === "function" ? fileName() : fileName;

function CustomExportMenuItem(props) {
  const { getData, fileType, fileName, label } = props;

  const downloadFile = () => {
    const data = getData();
    const blob = new Blob([data], { type: fileType });
    const hiddenElement = document.createElement("a");
    hiddenElement.download = getFileName(fileName);
    hiddenElement.href = URL.createObjectURL(blob);
    hiddenElement.click();
    hiddenElement.remove();
  };

  return <Box onClick={downloadFile}>{label}</Box>;
}

CustomExportMenuItem.propTypes = {
  getData: PropTypes.func.isRequired,
  fileType: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  fileName: PropTypes.oneOfType([PropTypes.string, PropTypes.func]).isRequired,
};

export default function CustomExportButton(props) {
  const { disabled, fileName, exportDataGetter } = props;
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        variant="outlined"
        onClick={handleClick}
        disabled={disabled}
        sx={{
          fontSize: "14px",
          textTransform: "capitalize",
        }}
      >
        Export
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        {!exportDataGetter ? (
          <GridCsvExportMenuItem
            options={{ fileName: getFileName(fileName) }}
          />
        ) : (
          <CustomExportMenuItem
            fileName={fileName}
            fileType="text/csv"
            label="Download as CSV"
            getData={exportDataGetter}
          />
        )}
      </Menu>
    </>
  );
}

CustomExportButton.propTypes = {
  exportDataGetter: PropTypes.func,
  disabled: PropTypes.bool,
  fileName: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
};

CustomExportButton.defaultProps = {
  exportDataGetter: null,
  disabled: false,
  fileName: () => `measures_${new Date().toISOString()}.csv`,
};
